import ProfileItemForm from "./ProfileItemForm";

export default class ProfileDocumentForm extends ProfileItemForm {

    static ItemType = 'Document'

    static FormClass = 'talent-role-form add-talent-form add-doc-form '

    static TypeConfig = {
        icon: 'fa fa-file-alt',
        color: TB.config('color.light_purple')
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        if(typeof model?.path === 'object' && model.path.name) {
            model.name = model.path.name;
        }

        return this.setState({model})
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {


        return [
            {
                style: styles.fieldSection,
                fields: {
                    type: {
                        type: 'select',
                        label: TB.trans('talent.profile_document_form.document_type_label'),
                        options: laravel.talent_profile_document_types,
                        required: true,
                        placeholder: TB.trans('talent.profile_document_form.document_type_placeholder'),
                        style: styles.field,
                        columns: 8
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    path: {
                        type: 'file',
                        required: true,
                        size: this.props.model?.size,
                        viewable: typeof this.props.model.path === 'string',
                        label: TB.trans('talent.profile_document_form.upload_document_label'),
                        fileNameDisplay: () => {
                            return this.state.model.name || this.props.model.display_name
                        },
                        style: styles.field,
                        columns: 8
                    }
                }
            }
        ]
    };

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};